import { LegacyStack } from '@shopify/polaris';
import DropdownButton from '../Common/DropdownButton';
import { filterPermissionsMenu } from '../../../services/permissionsService';

const ViewSellPrimaryActions = ({ stock, status, onInvoice, onDelete }) => {
  const dropdownItems = filterPermissionsMenu([
    {
      content: 'Facturar',
      onAction: () => onInvoice(),
      permissions: ['SELL:CLOSE'],
      disabled: status === 'INVOICED' || !stock.length,
    },
    {
      content: 'Borrar',
      onAction: () => onDelete(),
      disabled: status === 'INVOICED',
      permissions: ['SELL:DELETE'],
      destructive: true,
    },
  ]);

  return (
    <LegacyStack>
      {dropdownItems.length && (
        <DropdownButton
          title="Acciones"
          items={dropdownItems}
          buttonProps={{ disabled: dropdownItems.reduce((acc, cur) => acc && cur.disabled, true) }}
        />
      )}
    </LegacyStack>
  );
};

export default ViewSellPrimaryActions;
